'use client'

import { useEffect, useState } from 'react'
import { Clock } from 'lucide-react'
import { isWithinWorkingHours } from '@/lib/utils'

export function OpeningHours() {
    const [isOpen, setIsOpen] = useState(false)

    useEffect(() => {
        // Initial check
        setIsOpen(isWithinWorkingHours())

        // Update every minute
        const interval = setInterval(() => {
            setIsOpen(isWithinWorkingHours())
        }, 60000)

        return () => clearInterval(interval)
    }, [])

    return (
        <div className="flex items-start">
            <Clock className="mr-4 h-5 w-5 text-[#a19b92]" />
            <div>
                <div className="flex items-center gap-2">
                    <p className="font-medium">Öffnungszeiten</p>
                    <div className={`w-2 h-2 rounded-full ${isOpen ? 'bg-green-500' : 'bg-red-500'}`} />
                </div>
                <p className="text-[#a19b92]">Mo-Fr: 9:00-17:00 Uhr, Sa: nach Vereinbarung</p>
            </div>
        </div>
    )
} 